const CAPTURE_MARKER_KEY = 'auth.recent_location_capture'
const CAPTURE_MARKER_MAX_AGE_MS = 30_000

interface CaptureMarker {
  accountGuid: string
  createdAt: number
}

type CaptureStorage = Pick<Storage, 'getItem' | 'removeItem' | 'setItem'>

export function markRecentLocationCapture(storage: CaptureStorage, accountGuid: string): void {
  const marker: CaptureMarker = {
    accountGuid,
    createdAt: Date.now(),
  }

  try {
    storage.setItem(CAPTURE_MARKER_KEY, JSON.stringify(marker))
  } catch {
    // Storage can be unavailable in restricted browser contexts. The capture
    // still works; the return trip will simply perform the normal info refresh.
  }
}

export function consumeRecentLocationCapture(storage: CaptureStorage, accountGuid: string): boolean {
  let raw: string | null = null

  try {
    raw = storage.getItem(CAPTURE_MARKER_KEY)
    storage.removeItem(CAPTURE_MARKER_KEY)
  } catch {
    return false
  }

  if (!raw) return false

  try {
    const marker = JSON.parse(raw) as Partial<CaptureMarker>
    const age = Date.now() - Number(marker.createdAt)

    return marker.accountGuid === accountGuid
      && Number.isFinite(age)
      && age >= 0
      && age <= CAPTURE_MARKER_MAX_AGE_MS
  } catch {
    return false
  }
}
